import * as Pokedex from "./dex";
import * as Inventory from "./inventory";
import * as Shop from "./shop";
import * as Leaderboard from "./leaderboard";
import * as General from "./general";

const Cache = {
  Pokedex,
  Inventory,
  Shop,
  Leaderboard,
  General,
  invalidateAll: (queryClient) => {
    queryClient.invalidateQueries();
  },
};

export default Cache;
